module.exports = __webpack_public_path__ + "static/media/thumbnail_virtual_card_front.e6310274.png";